import * as React from "react";
import { useHistory, useLocation } from "react-router";
import { VerifyCodeWidget } from "user-management/src/components/verifyCodeWidget";
import { UserAuthenticationWrapper } from "../demo/userAuthenticationWrapper";
import { LandingPageLayout } from "fe-web-components/layout/landingPageLayout";
import { DemoLayoutTitle } from "../demo/demoLanding";
//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientVerify = () => {
  const history = useHistory();

  const { search } = useLocation();

  const params = new URLSearchParams(search);

  const code = params.get("code") ? params.get("code").replace(/N/g, "") : null;

  // console.log("received verification code", code);

  if (!code)
    return (
      <LandingPageLayout onHome={() => history.push("/")}>
        <DemoLayoutTitle>This link is invalid</DemoLayoutTitle>
      </LandingPageLayout>
    );

  return (
    <LandingPageLayout>
      <UserAuthenticationWrapper subtitle={"Sign up"}>
        <VerifyCodeWidget
          hideLogo
          code={code}
          userName={params.get("username")}
          onComplete={() => history.push("/demosignup/login")}
        />
      </UserAuthenticationWrapper>
    </LandingPageLayout>
  );
};
